import { render, staticRenderFns } from "./areasComponent.vue?vue&type=template&id=1845080a&scoped=true&"
import script from "./areasComponent.vue?vue&type=script&lang=js&"
export * from "./areasComponent.vue?vue&type=script&lang=js&"
import style0 from "./areasComponent.vue?vue&type=style&index=0&id=1845080a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1845080a",
  null
  
)

export default component.exports